import React from 'react';
import './playerStyles.css';

// props :{
//     currentPlayer : string,
//     players : string[],
// }
export const Player = (props) =>{
    return (
        <div>
            <p className="player"> {props.players[props.currentPlayer]}'s turn </p>
        </div>
    )
}
